<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      v-if="brokerLogo"
      class="w-21 h-11"
      :src="brokerLogo"
      alt="broker logo"
    />
  </div>
  <div class="my-4 mb-4 w-full border-t border-light-gray md:border-none" />
  <layout>
    <div>
      <h1 class="self-start py-1 text-left text-2xl text-dark-gray">
        Select Carrier
      </h1>
      <p class="my-4 text-left text-1md text-dark-gray">
        Who do you want to onboard to {{ broker?.legal_name }}?
      </p>
      <div class="flex flex-col justify-start">
        <form-field
          id="search_input"
          label="Search my Carriers"
          :value="search_input"
          placeholder="Enter Carrier Name"
          :on-input="onInput"
          name="search_input"
          class="text-1md text-dark-blue"
        />
      </div>
      <section
        v-if="carriers.length"
        class="my-2 flex flex-col justify-start"
      >
        <span class="mb-2 w-full text-left text-xxs font-bold uppercase"
          >My carriers</span
        >
        <div class="max-h-56 overflow-x-hidden overflow-y-visible">
          <div
            v-for="(carrier, index) in carriers"
            :key="index"
          >
            <round-radio-button
              :item="carrier.legal_name"
              :value="carrier.legal_name"
              name="searched_carrier"
              :subtext="carrier.joined_identifiers"
              custom-class="text-body-color"
              subtext-class="text-sm md:font-light radio-btn-subtitle"
              :checked="carrier.id === selected_carrier?.id"
              :handle-click="() => setCarrier(carrier)"
              class="my-2 text-1md"
            />
          </div>
        </div>
      </section>
      <section v-else>
        <div class="my-3 rounded-md bg-off-white p-4">
          <small class="text-left text-1md text-body-color">
            No results found
          </small>
        </div>
      </section>
      <button-main
        class="mb-4 flex flex-row items-center justify-center"
        :disabled="!selected_carrier"
        :is-loading="loading"
        @click="handleSubmit"
      >
        Continue
      </button-main>
      <p class="mb-2 mt-6 text-1md text-body-color">
        Want to add more carriers to your account?
      </p>
      <button-main
        variant="link"
        class="mb-4 flex w-full flex-row items-center justify-center text-yellow-500"
        @click="$router.push('/dispatcher')"
      >
        Go to Dispatcher Portal
        <img
          class="ml-1 h-5 w-5"
          src="@/assets/launch-yellow-icon.svg"
          alt="launch-icon"
        />
      </button-main>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import FormField from '@/components/FormField.vue';
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';

export default {
  name: 'SelectCarrier',
  components: {
    Layout,
    FormField,
    ButtonMain,
    RoundRadioButton,
  },
  data() {
    return {
      filter_value: '',
      search_input: '',
      selected_carrier: null,
      contact_recipients: [],
      loading: false,
    };
  },
  computed: {
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.legal_name || '';
    },
    carrierList() {
      if (this.$store.state.dispatcherConnections?.carrierList.length) {
        return this.$store.state.dispatcherConnections?.carrierList.map(
          (carrier) => {
            let joined_identifiers = '';

            const allowedIdentifiers = carrier.identifiers.filter(
              (identifier) => {
                return (
                  identifier.is_type === 'MC' || identifier.is_type === 'DOT'
                );
              }
            );
            allowedIdentifiers.forEach((indentifier) => {
              joined_identifiers += `${indentifier.is_type}# ${indentifier.value} `;
            });
            return {
              ...carrier,
              joined_identifiers,
            };
          }
        );
      }
      return [];
    },
    carriers() {
      if (this.filter_value) {
        return this.carrierList.filter((carrier) => {
          const uppercase_value = this.filter_value.toUpperCase();
          return carrier.legal_name.includes(uppercase_value);
        });
      }
      return this.carrierList;
    },
    broker() {
      return this.$store.state.company?.company;
    },
    brokerLogo() {
      return this.$store.state.brokers?.logo?.url || null;
    },
  },
  async created() {
    const clientId = localStorage.getItem('client_id');
    await this.$store.dispatch('brokers/getLogoByClientId', clientId);
    // verify that we have the OAuth authorization that we need
    console.log(this.$route.params);
    if (this.$route.query.client_id == null) {
      return this.$router.push({ name: 'Dispatcher Dashboard' });
    }
    // let redirectAfterSignIn = localStorage.getItem('redirect_url_after_sigin')
    // if(redirectAfterSignIn == null){
    // return this.$router.push({name: 'Dispatcher Dashboard'})
    // }

    await this.$store.dispatch(
      'company/getCompanyByClientId',
      localStorage.getItem('client_id')
    );
  },
  async beforeMount() {
    await this.$store.dispatch('dispatcherConnections/getListOfCarriers');
  },
  methods: {
    async handleSubmit() {
      this.loading = true;
      await this.$store.commit(
        'dispatchers/setSelectedCarrierId',
        this.selected_carrier.id
      );
      this.$router.push({
        path: '/oauth/authorizations',
        query: this.$route.query,
      });
      // const res = await this.$store.dispatch("users/hasCarrierBeenClaimed", this.selected_carrier.id);
      // if (res.status === 200) {
      //   this.$store.commit("carriers/setMaskedContacts", res.data);
      // }
      // this.loading = false;
      // this.$router.push({
      //   name: "JoinCarrier"
      // });
    },
    setCarrier(carrier) {
      const oldCarrier = { ...carrier };
      delete oldCarrier.joined_identifiers;
      this.selected_carrier = oldCarrier;
      this.$store.commit('carriers/setCarrierDetails', this.selected_carrier);
    },
    onInput(e) {
      const value_to_search = e.target.value;
      this.filter_value = value_to_search;
    },
  },
};
</script>
<style>
.radio-btn-subtitle {
  font-size: 10px;
  line-height: 15px;
}
</style>
